export default defineNuxtRouteMiddleware((to, from) => {
  const authenticatedCookie = useCookie('authenticated')

  if (!authenticatedCookie.value) {
    const redirect = encodeURIComponent(to.fullPath)
    return navigateTo(`/login?redirect=${redirect}`)
  }
})